// extracted by mini-css-extract-plugin
export default {"Services":"Services_Services__+EAcF","symbols":"Services_symbols__XeLPo","symbol":"Services_symbol__mATK4"};